import React from 'react';
import PropTypes from 'prop-types';
import PanelClaro from 'newComponents/PanelClaro/PanelClaro';
import HeaderSection from './components/HeaderSection';
import InfoSection from './components/InfoSection';
import ButtonSection from './components/ButtonSection';

const Password = ({
  label,
  className,
  form,
  errors,
  isEditMode,
  loading,
  onChange,
  onSave,
  onToggle,
}) => (
  <PanelClaro sectionName="micuentapassword">
    <div className="row">
      <HeaderSection labelHeader={label.title} labelTitle={label.subTitle} />

      <div className="col-xs-12 padding-top-1">
        <div className="row form-horizontal">
          {!isEditMode ? (
            <InfoSection
              name="password"
              placeholder={label.password}
              label={label.password}
              value="********"
            />
          ) : (
            <>
              <InfoSection
                name="oldpassword"
                placeholder={label.placeholder}
                label={label.oldPassword}
                value={form.oldpassword}
                error={errors.oldpassword}
                editEnable={isEditMode}
                onChange={onChange}
              />
              <InfoSection
                name="newpassword"
                placeholder={label.placeholder}
                label={label.newPassword}
                value={form.newpassword}
                error={errors.newpassword}
                editEnable={isEditMode}
                onChange={onChange}
              />
              <InfoSection
                name="controlpassword"
                placeholder={label.placeholder}
                label={label.controlPassword}
                value={form.controlpassword}
                error={errors.controlpassword}
                editEnable={isEditMode}
                onChange={onChange}
              />
            </>
          )}
        </div>
      </div>

      <ButtonSection
        labelRecomendation={label.recomendation}
        labelRequired={label.required}
        labelModify={label.modify}
        labelCancel={label.cancel}
        labelSave={label.save}
        classNameModify={className.modify}
        editEnable={isEditMode}
        loading={loading}
        onSave={onSave}
        onToggle={onToggle}
      />
    </div>
  </PanelClaro>
);

Password.propTypes = {
  label: PropTypes.object,
  className: PropTypes.object,
  form: PropTypes.shape({
    oldpassword: PropTypes.string,
    newpassword: PropTypes.string,
    controlpassword: PropTypes.string,
  }),
  errors: PropTypes.object,
  loading: PropTypes.bool,
  isEditMode: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};
export default Password;
